import Component from './BrowseHapps'

export default Component
